var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.$style.baseBtnIcon,on:{"click":function($event){$event.preventDefault();return _vm.emitClick($event)}}},[_c('div',{class:_vm.$style.icon},[_vm._t("icon")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }